export default {
    InternalOrder: {
        ps1: 'Note: Depending on the actual warehouse order processing situation, any order cancellations or modifications may not be successful.',
        ps2: 'Please first input the shipping information for the order.',
        Common: 'Common Query:',
        JobID: 'JobID/Tracking No.',
        CourierName: 'Courier Service Name',
        byorder: 'Manually download authorized channel orders',
        No: 'Order No.',
        number: 'Customer Order No./Internal Order No.',
        store: 'Pickup Store',
        Sales: 'Sales Staff',
        Method: 'Pickup Method',
        Receiving: 'Receiving Status',
        Doc: 'Logistics Number',
        Email: 'E-mail Address',
        orderCode: 'Order creation time',
        ERP: 'ERP Timeout Order',
        SAP: 'SAP Timeout Order',
        WMS: 'WMS Timeout Order',
        SKU: 'SKUCode',
        source: 'Order Source',
        there: 'With/Without Gift',
        nickname: "Buyer's Nickname",
        name: 'Consignee Name',
        phone: 'Consignee Phone Number',
        Buyer: "Buyer's Comments",
        Merchant: "Merchant's Comments",
        Label: 'Label',
        Aggregation: 'Aggregated Status:',
        Shipment: 'Delivery Status',
        status: 'Receiving Status',
        occupied: 'Reservation Status',
        Sourcing: 'Sourcing Status',
        Pending: 'Suspension Status',
        Pre: 'Preemption Write-back Status',
        update: 'Delivery Write-back Status',
        Time: 'Time Query:',
        order: '3rd Party Order Time',
        orderOFF: 'Order closure time',
        orderStart: 'Starting time for third-party ordering',
        orderEnd: 'End time of third-party ordering',
        InternalStart: 'Internal order creation start time',
        InternalEnd: 'Internal order creation end time',
        EstimatedStart: 'Estimated shipping start time',
        EstimatedEnd: 'Estimated delivery end time',
        Start: 'Start Date',
        End: 'End Date',
        Payment: 'Payment Time',
        Internal: 'Internal Creation Time',
        Estimated: 'Estimated Delivery Time',
        Shipmen: 'Delivery Time',
        Confirm: 'Confirmation of Receipt Time',
        Amount: 'Amount Query:',
        Total: 'Total Product Amount',
        Minimum: 'Minimum Amount',
        Maximum: 'Maximum Amount',
        payable: "Buyer's Payable Amount",
        cost: 'Total Product Cost',
        All: 'All',
        create: 'Create Order',
        Product: 'Product Information',
        form: {
            number: 'Customer Order No.',
            Internal: 'CSG Order No.',
            err: 'ErrorMsg',
            Timeout: 'Timeout Duration (hours)',
            sapOrderNo: 'SAP Order No.',
            wmsOrderNo: 'WMS Order No.',
            orderStatusStr: 'Status',
            pickUpTime: 'Pickup',
            OriginalInternal: 'Original internal Order No.',
            Label: 'Label',
            Sales: 'Store',
            channel: 'Sales Channel',
            employee: 'Sales Staff',
            store: 'Pickup Store',
            Source: 'Order Source',
            Product: 'Goods Qty',
            nickname: "Buyer's Nickname",
            comments: "Buyer's Comments",
            Merchant: "Merchant's Comments",
            Method: 'Shipping method',
            name: 'Consignee name',
            phone: 'Consignee phone number',
            address: 'Consignee address',
            Shipment: 'Shipping status',
            document: 'Job Id/Tracking No.',
            status: 'Delivery status',
            Total: 'Total amount of goods',
            Buyer: 'Buyer payable',
            cost: 'Total cost of goods',
            placement: '3rd Party Order Time',
            time: 'Payment time',
            creation: 'ERP Order Time',
            delivery: 'Estimated delivery time',
            Pre: 'Preemptive status',
            Sourcing: 'Sourcing Status',
            Pending: 'Suspend Status',
            emptive: 'Preemptive write-back status',
            Update: 'Shipping write-back status',
            there: 'Presence of gifts',
            Delete: 'Delete?',
            AbnormalCause: 'Exception Reason',
            sapPushTime: 'SAP Push Time',
            sapPullTime: 'SAP Processing Time',
            hjPushTime: 'HJ Push Time',
            hjLockTime: 'HJ Locking Time',
            hjShipmentTime: 'HJ Shipment Time',
            ERPCard: 'Duration of ERP Order Stuck (hours)',
            SAPCard: 'Duration of SAP Order Stuck (hours)',
            HJCard: 'Duration of WMS Order Stuck (hours)',
            tab: 'Valid Order',
            hjOrderStatus: 'HJ Order Status',
            sapOrderStatus: 'SAP Order Status',
        },
        AddException: 'Add Error Order',
        ReleaseException: 'Reprocess Error Order',
        ReleaseExceptions: 'Reprocess Error Order',
        LogisticsInformationExport: 'Logistics Information Export',
        failure: 'Click to view the reason for the failure',
        unshipped: 'unshipped',
        UnableToTakeDelivery: 'Unable to take delivery',
        Reason: 'Failure Reason',
        Exit: 'Exit Risk',
        Mega: 'Mega Order',
    }
};
